import { Spinner } from "@/components/Spinner";
import type { VariantProps } from "cva";
import { cva } from "cva";
import type { ButtonHTMLAttributes } from "react";

const button = cva("button", {
  variants: {
    intent: {
      primary: "bg-magenta uppercase text-white",
      secondary: "h-9 rounded bg-gray-400 text-sm text-gray-600",
      tertiary: "rounded bg-gray-600 bg-opacity-80 text-sm text-gray-500",
    },
    size: {
      small: "px-2.5 py-2 text-xs",
      medium: "px-4 py-2.5 text-base",
    },
    disabled: {
      true: "cursor-not-allowed opacity-50",
    },
    loading: {
      true: "cursor-not-allowed",
    },
  },
  compoundVariants: [
    {
      intent: "primary",
      size: "medium",
    },
    {
      loading: true,
      disabled: true,
      class: "opacity-100",
    },
  ],
  defaultVariants: {
    intent: "primary",
    size: "medium",
  },
});

export interface ButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "disabled">,
    VariantProps<typeof button> {}

export const Button = ({
  children,
  className,
  intent,
  size,
  loading,
  disabled,
  ...props
}: ButtonProps) => {
  return (
    <button
      className={`flex w-full items-center justify-center gap-2 font-bold outline-none transition-all duration-150 ${button(
        { intent, size, disabled, loading, class: className },
      )}`}
      disabled={disabled ?? false}
      {...props}
    >
      {!loading && children}
      {loading && <Spinner />}
    </button>
  );
};
